import { KtList } from '@norlys-a-s/norlys-play-kmm';

import { kmm } from './kmm';

interface RemoveCustomerDevicesParams {
  uids: string[];
  sid?: number;
  mediaId?: number;
}

export async function removeCustomerDevices(payload: RemoveCustomerDevicesParams): Promise<boolean> {
  return kmm((repo) =>
    repo.removePlaybackDevices(KtList.fromJsArray(payload.uids), payload.sid, payload.mediaId)
  );
}

export default removeCustomerDevices;
